/* RESPONSIBLE TEAM: team-frontend-tech */
import Predicate from './predicate';
const OPTION_MAPPINGS = {
  eq: 'in',
  ne: 'nin'
};
export default Predicate.extend({
  normalize(modelClass, resourceHash) {
    let result = this._super(...arguments);
    let comparison = result.data.attributes.comparison;
    let equalOrNotEqualRegex = /^(eq|ne)$/;
    if (comparison && equalOrNotEqualRegex.test(comparison)) {
      result.data.attributes.comparison = OPTION_MAPPINGS[comparison];
    }
    return result;
  }
});